require('./core');
import 'bootstrap5';
require('./default');

import 'bootstrap5/scss/bootstrap.scss';
import '../css/default.css';
